/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualTaxDto } from '../../models/backend-actual-tax-dto';
import { BackendActualTaxRequestDto } from '../../models/backend-actual-tax-request-dto';

export interface MonitoringActualsTaxesUpdate$Params {
  id: number;
  body: BackendActualTaxRequestDto;
}

export function monitoringActualsTaxesUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsTaxesUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualTaxDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsTaxesUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualTaxDto>;
    }),
  );
}

monitoringActualsTaxesUpdate.PATH = '/api/monitoring/actuals/taxes/{id}/';
